(function () {

  'use strict';

  angular
    .module('mgpCorregedoriaApp.validacao')
    .controller('RelatorioAvalOrgao', RelatorioAvalOrgao);

  function RelatorioAvalOrgao(RelatorioAvalOrgaoService,
     OrgaoService,
     CONSTANTS,
     $scope,
     blockUI,
     i18n,
     FileSaver,
     toaster,
     Blob) {

    var vm = this;
    vm.init = init;
    vm.consultarOrgao = consultarOrgao;
    vm.adicionarOrgao = adicionarOrgao;
    vm.removerOrgao = removerOrgao;
    vm.subirPosicao = subirPosicao;
    vm.descerPosicao = descerPosicao;
    vm.exibeBotaoAdicionar = exibeBotaoAdicionar;
    vm.exportarExcel = exportarExcel;

    vm.init();

    function init() {
      vm.orgaosList = [];
      vm.permiteExportacao = false;
      vm.quantidadeMaxima = {
        quantidade: CONSTANTS.QUANTIDADE_MAXIMA_ORGAO_RELATORIO_ORGAO
      };
    }

    function consultarOrgao(query, timeoutPromise) {
      return OrgaoService.consultarOrgao(query, timeoutPromise);
    }

    function adicionarOrgao() {

      vm.permiteExportacao = true;

      if(vm.orgaosList.length < CONSTANTS.QUANTIDADE_MAXIMA_ORGAO_RELATORIO_ORGAO) {
        vm.orgaosList.push(vm.orgaoSelecionado.originalObject);
      }

      $scope.$broadcast('angucomplete-alt:clearInput');
    }

    function exibeBotaoAdicionar() {
      return vm.orgaosList.length < CONSTANTS.QUANTIDADE_MAXIMA_ORGAO_RELATORIO_ORGAO;
    }

    function removerOrgao(idx) {
      vm.orgaosList.splice(idx, 1);

      if(vm.orgaosList.length === 0 ) {
        vm.permiteExportacao = false;
      } else {
        vm.permiteExportacao = true;
      }
    }

    function subirPosicao(idx) {
      if (idx > 0) {
        var temp = vm.orgaosList[idx-1];
        vm.orgaosList[idx-1] = vm.orgaosList[idx];
        vm.orgaosList[idx] = temp;
      }
    }

    function descerPosicao(idx) {
      if (idx !== vm.orgaosList.length - 1) {
        var temp = vm.orgaosList[idx + 1];
        vm.orgaosList[idx+1] = vm.orgaosList[idx];
        vm.orgaosList[idx] = temp;
      }
    }

    function exportarExcel() {
      blockUI.start();
      RelatorioAvalOrgaoService.exportarExcel(vm.orgaosList)
      .then( (response) => {
        if (response.status === 204) {
          toaster.pop("warning",i18n.translate("relatorio.avaliacao.orgao.titulo"),
          i18n.translate("relatorio.sem.dados"));
        }
        if (response.status === 200) {
         var blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
         FileSaver.saveAs(blob, 'relatorio-avaliacao-orgao.xlsx');
       }
      }).finally(function(){
        blockUI.stop();
      });
    }
  }

})();
